'use client'

import { RouteError } from '@/components/RouteError'

export default RouteError
